// Util
SR.util = {
    versionToNumber: function(version) {
        if (version) {
            return Number(version.replace(/\./gi, ''));
        } else {
            return -1;
        }
    },
    formatDate: function(date) {
        date = date.split(',');
        var nowDate = new Date();
        var fDate = '';
        var isToday = +date[1] === nowDate.getMonth() + 1 && +date[2] === nowDate.getDate();

        $(date).each(function(index, item) {
            if (+item === nowDate.getFullYear()) {
                return;
            }
            item = item.length === 1 ? '0' + item : item;
            fDate += item;
            if (index < 2) {
                fDate += '-';
            } else if (index === 2) {
                fDate += ' ';
            } else if (index < 5) {
                fDate += ':';
            }
        });
        fDate = isToday ? fDate.split(' ')[1] : fDate;
        return fDate;
    },
    shuffle: function(array) {
        var m = array.length,
            t,
            i;
        // 如果还剩有元素…
        while (m) {
            // 随机选取一个元素…
            i = Math.floor(Math.random() * m--);
            // 与当前元素进行交换
            t = array[m];
            array[m] = array[i];
            array[i] = t;
        }
        return array;
    },
    urlParam: function(name, url) {
        var url = url || window.location.href;
        var reg = new RegExp('[?&]' + name + '=([^&]*)(&|$)', 'i');
        var results = url.match(reg);
        if (results === null) {
            return null;
        } else {
            return results[1] || 0;
        }
    },
    jsonToQuery: function(json, alias) {
        if (!json) {
            return;
        }
        alias = alias || {};
        var query = '';
        for (var key in json) {
            var keyName = alias[key] || key;
            query += keyName + '=' + json[key] + '&';
        }
        query = query.slice(0, -1);
        return query;
    },
    enterAnimate: function($el, enterAnimateStyle) {
        $el.removeClass('hide').addClass(enterAnimateStyle);
    },
    outAnimate: function($el, enterAnimateStyle, outAnimateStyle, outAnimateTime, removeTime) {
        setTimeout(function() {
            $el.removeClass(enterAnimateStyle).addClass(outAnimateStyle);
            setTimeout(function() {
                $el.remove();
            }, removeTime);
        }, outAnimateTime);
    },
    getStorage: function(key) {
        if (key !== undefined) {
            return SR.data.SRStorage[SR.permissions.sn][key];
        } else {
            console.log('get SRStorage error, key is undefined');
        }
    },
    updateStorage: function(key, val) {
        if (key && val !== undefined) {
            SR.data.SRStorage[SR.permissions.sn][key] = val;
            localStorage.setItem('SRStorage', JSON.stringify(SR.data.SRStorage));
        } else {
            console.log('update SRStorage error, please check the parmas: ', key, val);
        }
    },
    delStorage: function(key) {
        if (key !== undefined) {
            delete SR.data.SRStorage[SR.permissions.sn][key];
        } else {
            console.log('del SRStorage error, key is undefined');
        }
    },
    debounce: function(func, delay) {
        var timer = null;
        return function () {
            var context = this;
            var args = arguments;
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            timer = setTimeout(function () {
                func.apply(context, args);
            }, delay);
        }
    },
    throttle: function(func, delay) {
        var lastTime = null;
        return function () {
            var nowTime = +new Date();
            if (nowTime - lastTime > delay || !lastTime) {
                func();
                lastTime = nowTime;
            }
        }
    }
};
